// extracted by mini-css-extract-plugin
export default {"container":"crickettimes_container__mQykW"};